
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Button from 'components/common/Button';
import Divider from 'components/common/Divider';
import ExploitCard from 'components/exploits/ExploitCard';
import ContentPageLayout from 'layouts/ContentPageLayout';
import { defaultSEO } from 'lib/next-seo.config';
import { Exploit, REPORT_EXPLOIT_URL, getAllExploits } from 'lib/utils/exploits';
import { GetStaticProps, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
interface Props {
    exploits: Exploit[];
}
const ExploitOverviewPage: NextPage<Props> = (props) => {
    const { t } = useTranslation();
    const totalAmount = `$${Math.floor(props.exploits.reduce((prev, curr) => prev + curr.amount, 0))}M`;
    const earliestYear = props.exploits.at(-1).date.slice(0, 4);
    return (<>
      <NextSeo {...defaultSEO} title={t('exploits:meta.title')} description={t('exploits:meta.description', { totalAmount, earliestYear })}/>

      <ContentPageLayout>
        <div className="flex flex-col gap-4">
          <div className="flex sm:flex-row flex-wrap gap-2 items-center justify-between">
            <div className="w-">
              <h1>{t('exploits:title')}</h1>
              <p>{t('exploits:subtitle', { totalAmount, earliestYear })}</p>
            </div>
            <Button size="md" style="primary" href={REPORT_EXPLOIT_URL} external className="w-fit shrink-0">
              {t('common:buttons.report_exploit')}
            </Button>
          </div>
          <Divider />
          <p>{t('exploits:description')}</p>
          {props.exploits.map((exploit) => (<ExploitCard key={exploit.slug} exploit={exploit} overview/>))}
        </div>
      </ContentPageLayout>
    </>);
};
const getStaticProps: GetStaticProps<Props> = async () => {
    const exploits = await getAllExploits();
    return {
        props: {
            exploits,
        },
    };
};
export default ExploitOverviewPage;

    async function __Next_Translate__getStaticProps__18a60ca9dbd__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/exploits/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18a60ca9dbd__ as getStaticProps }
  